import template from './included-options.jade';
import possibleItems from '../../../enums/included-options';

export default angular
    .module('cian.addForm.priceIncludedOptions', [])
    .directive('cianAfPriceAndDealTermsIncludedOptions', () => ({
        scope: {},
        bindToController: {
            ad: '=',
            form: '=',
        },
        controller: ['$scope', function($scope) {
            this.ad.bargainTerms.includedOptions = this.ad.bargainTerms.includedOptions || [];
            this.items = possibleItems.map(item => ({
                ...item,
                checked: this.ad.bargainTerms.includedOptions.indexOf(item.value) !== -1
            }));

            $scope.$watch(() => this.items, newItems => {
                if (!newItems) return;
                this.ad.bargainTerms.includedOptions = newItems.map(item => item.checked ? item.value : undefined).filter(item => !!item);
            }, true);
        }],
        controllerAs: 'includedOptions',
        template,
    }))
    .name;
